import React, { InputHTMLAttributes, DetailedHTMLProps } from 'react';

type RadioDefaultProps = Omit<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'type'
>;

export interface RadioProps extends RadioDefaultProps {
    label?: JSX.Element | string;
    containerClassName?: string;
}

export const Radio = ({
    label,
    containerClassName,
    children,
    id,
    name,
    value,
    ...props
}: RadioProps): JSX.Element => {
    const internalId = id ?? name + '-' + String(value);

    return (
        <div className={containerClassName}>
            <input {...props} name={name} value={value} type="radio" id={internalId} />
            <label htmlFor={internalId}>{children || <p className="body">{label}</p>}</label>
        </div>
    );
};

Radio.displayName = 'RadioB2B';
export default Radio;
